// extracted by mini-css-extract-plugin
export default {"catalog":"Catalog_catalog__6dRCR","categoriesH":"Catalog_categoriesH__4rtQB","cardCategories":"Catalog_cardCategories__moLjf"};